(function($) {
    var searchToggle = $('.js-site-search-toggle');
    var searchLabel = searchToggle.find('.site-search-toggle__label');
    var searchArea = $('.site-search-area');
    var searchInput = $('.site-search #s');
    var searchText = {
        open: mousyLocalize.openSearch,
        close: mousyLocalize.closeSearch,
    };
    var closeSearch = searchArea.find('.svg-icon.icon-cross');    

    if (searchToggle.length && searchArea.length) {
        searchToggle.click(function(e) {
            e.preventDefault();
            searchArea.addClass('search-open');
            searchLabel.text(searchText.close);
            // For some reason directly applying focus doesn't work here.
            setTimeout(function() { searchInput.focus(); }, 100);
        });
    }

    if (closeSearch.length && searchArea.length) {
      searchArea.click(function(e) {
        if (e.target.matches('.site-search-area.search-open') || e.target.closest('.svg-icon.icon-cross')) {
          e.preventDefault();
          searchArea.removeClass('search-open');
          searchLabel.text(searchText.open);
        }
      });
    }
})(jQuery);
